import angular from 'angular';

(function() {
    'use strict';
    angular.module('app.core').factory('InvoiceTemplateAttribute', InvoiceTemplateAttributeData);

    /* @ngInject */
    function InvoiceTemplateAttributeData() {
        InvoiceTemplateAttribute.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            isStandard: isStandard
        };

        function InvoiceTemplateAttribute(invoiceTemplateAttributeData) {
            if (!invoiceTemplateAttributeData) {
                this.buildEmpty();
            } else {
                this.build(invoiceTemplateAttributeData);
            }
        }

        return InvoiceTemplateAttribute;

        /////////////////////
        function buildEmpty() {
            this.name = null;
            this.label = null;
            this.type = null;
            this.path = null;
            this.category = null;
            this.section = null;
            this.multiple = null;
            this.order = null;
            this.lad = null;
            this.mandatoryLad = null;
            this.saisie = null;
            this.mandatorySaisie = null;
            this.mappingLadAuto = null;
            this.mappingLadExt = null;
            this.visible = null;
            this.visibleLad = null;
            this.visibleSaisie = null;
            this.rawOrder = -1;
        }

        function build(invoiceTemplateAttributeData) {
            this.name = invoiceTemplateAttributeData.name || null;
            this.label = invoiceTemplateAttributeData.label || null;
            this.type = invoiceTemplateAttributeData.type || null;
            this.path = invoiceTemplateAttributeData.path || null;
            this.category = invoiceTemplateAttributeData.category || null;
            this.section = invoiceTemplateAttributeData.section || null;
            this.multiple = invoiceTemplateAttributeData.multiple || null;
            this.order = invoiceTemplateAttributeData.order;
            this.lad = invoiceTemplateAttributeData.lad;
            this.mandatoryLad = invoiceTemplateAttributeData.mandatoryLad || null;
            this.saisie = invoiceTemplateAttributeData.saisie;
            this.mandatorySaisie = invoiceTemplateAttributeData.mandatorySaisie || null;
            this.mappingLadAuto = invoiceTemplateAttributeData.mappingLadAuto || null;
            this.mappingLadExt = invoiceTemplateAttributeData.mappingLadExt || null;
            this.visible = invoiceTemplateAttributeData.visible;
            this.visibleLad = invoiceTemplateAttributeData.visibleLad;
            this.visibleSaisie = invoiceTemplateAttributeData.visibleSaisie;
            this.rawOrder = invoiceTemplateAttributeData.rawOrder;
        }

        function isStandard() {
            return this.mandatoryLad || this.mandatorySaisie || this.rawOrder !== -1;
        }
    }
})();
